import type { PaxInfo } from '../../../types/api/v1/obt/air/air_search_response';
import type { Preference } from '../../../types/api/v1/obt/common/common';

export function getLegPreferencesForPaxInfo(paxInfo: PaxInfo[], legNumber = 0): Preference[] {
  return paxInfo[0].fareComponents[0].legInfo[legNumber].preferences;
}
